import styled from '@emotion/styled';
import { ExpandIcon } from 'src/domains/layouts/shared/assets/icons/ExpandIcon';
import { withConfig } from 'src/withConfig';
import { CloseIcon } from 'src/ui/assets/icons/other/CloseIcon';

export const GameViewDesktopContainer = withConfig(theme => styled('div', { label: 'GameViewDesktopContainer' })`
    background-color: ${theme.star.casino.casinoMini.colors.bgPrimary};
    border-radius: ${theme.star.casino.casinoMini.radius} ${theme.star.casino.casinoMini.radius} 0 0;
    margin: 0 10px 8px 10px;
    @media ${theme.star.mediaQuery.desktop} {
        border-radius: ${theme.star.casino.casinoMini.radius};
    }
`);

export const GameViewMobileContainer = withConfig(theme => styled('div', { label: 'GameViewMobileContainer' })`
    animation: slidePreviewIn .5s 1 forwards;
    background-color: ${theme.star.casino.casinoMini.colors.bgPrimary};
    border-radius: ${theme.star.casino.casinoMini.radius};
    inset: calc(100% - 43px) 0 auto auto;
    position: fixed;
    width: 100%;
    z-index: ${theme.star.zIndexCasino.miniGamesGameContainer};
    @media ${theme.star.mediaQuery.xxMobile} {
        max-width: 390px;
    }

    @keyframes slidePreviewIn {
        from { transform: translateY(0); }
        to { transform: translateY(-290px); }
    }
`);

export const PreviewHeader = withConfig(theme => styled('div', { label: 'PreviewHeader' })`
    align-items: center;
    color: ${theme.star.casino.txtColor};
    display: flex;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 8px;
    justify-content: start;
    line-height: ${theme.star.lineHeight[200]};
    padding: 8px;
    width: 100%;
    @media ${theme.star.mediaQuery.desktop} {
        border-radius: 4px 4px 0 0;
        width: auto;
    }
`);

export const GamePreviewTitle = styled('span', { label: 'GamePreviewTitle' })`
    flex: 1 1 auto;
`;

export const ExpandIconWrapper = withConfig(theme => styled(ExpandIcon, { label: 'ExpandIconWrapper' })`
    color: ${theme.star.casino.casinoMini.colors.txtPrimary};
    cursor: pointer;
    fill: currentcolor;
    padding: 1px;
`);

export const ClosePreviewIcon = withConfig(theme => styled(CloseIcon, { label: 'ClosePreviewIcon' })`
    cursor: pointer;
    color: ${theme.star.casino.casinoMini.colors.txtPrimary};
    padding: 4px;
`);

export const LaunchMiniGameBody = styled('div', { label: 'LaunchMiniGameBody' })`
    margin: 0 auto;
    width: 260px;
    height: 158px;
`;

export const LaunchMiniGameBodyMobile = styled('div', { label: 'LaunchMiniGameBodyMobile' })`
    height: 214px;
    margin: auto;
    text-align: center;
    width: 100%;
`;

export const LaunchMiniGameBodyIframe = styled('iframe', { label: 'LaunchMiniGameBodyIframe' })`
    border: none;
    height: 100%;
    width: 100%;
`;
